import { Video, Instagram } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { IMAGES, CONTACT } from "../data/content";

export default function VideoSessions() {
  return (
    <main className="pt-20 sm:pt-24">
      <section className="relative py-40 overflow-hidden noise-overlay" data-testid="video-hero">
        <img src={IMAGES.coach} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/75 to-[#050505]/50" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
          <Reveal>
            <Overline>Our Video Sessions — Elite Partnership</Overline>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter max-w-3xl" data-testid="video-headline">
              Analysis That <span className="text-[#D4AF37]">Rewires</span> Game Intelligence.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-24" data-testid="video-details">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <Reveal>
            <p className="text-white/70 text-base sm:text-lg leading-relaxed">
              Zavi FC works in technical collaboration with <span className="text-white font-semibold">Pulkitveer</span>, first-team analyst at an ISL club (name of the club will be revealed soon). Our players watch games broken down frame by frame — positioning, scanning, decision windows — the same way professionals do in Spain, England, Germany and other European nations. This is how game IQ is actually built: not by running more drills, but by understanding the game at a deeper level than your opponent.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="mt-12">
            <div className="border-l-4 border-[#D4AF37] bg-[#D4AF37]/10 p-8 flex items-center gap-5" data-testid="video-callout">
              <Video size={28} className="text-[#D4AF37] shrink-0" />
              <p className="font-heading text-lg sm:text-xl font-black uppercase tracking-wide text-white">
                Monthly Video Breakdowns & World Class Analysis.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.25} className="mt-16">
            <p className="text-white/60 text-sm mb-6">Follow us on Instagram to stay updated on such masterclasses.</p>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="video-cta-instagram"
              className="inline-flex items-center gap-3 bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-sm px-10 py-4 rounded-sm transition-all duration-200 hover:bg-[#F3D059] hover:-translate-y-1 gold-glow"
            >
              <Instagram size={16} /> @{CONTACT.instagramHandle}
            </a>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
